export const Routes = {
    // Authentication
    Login: { path: "/login" },
    Signin: { path: "/examples/sign-in" },
    Signup: { path: "/examples/sign-up" },
    ForgotPassword: { path: "/examples/forgot-password" },
    ResetPassword: { path: "/examples/reset-password" },
    Lock: { path: "/examples/lock" },

    // Main pages
    DashboardOverview: { path: "/dashboard/overview", protected: true },
    /* Transactions: { path: "/transactions" },
    Settings: { path: "/settings" },
    Upgrade: { path: "/upgrade" },
    BootstrapTables: { path: "/tables/bootstrap-tables" }, */
    /* Users: { path: "/components/old-users" },
    UsersList: { path: "/oldusers" }, */
    EditUser: { path: "/users/edit/:id" },
    MyProfile: { path: "/users/myprofile/:id" },
    UsersReportsList: { path: "/reports" },
    UserReports: { path: "/components/user-reports" },
    ReportDetail: { path: "/reports/:id" },
    MyReports: { path: "/my-reports" },
    UserDetails: { path: "/users/:id" },
    // News
    NewsList: { path: "/news" },
    NewsNew: { path: "/news/new" },
    NewsEdit: { path: "/news/:id/edit" },
    // Content Pages
    ContentList: { path: "/content-pages" },
    ContentEdit: { path: "/content-pages/:id/edit" },

    // Testimonials
    TestimonialsList: { path: "/testimonials" },
    TestimonialsNew: { path: "/testimonials/new" },
    TestimonialsEdit: { path: "/testimonials/:id/edit" },

    // New Users
    NewUsersList: { path: "/users" },
    UserEdit: { path: "/users/:id/edit" },
    
    // Groups
    GroupsList: { path: "/groups" },
    GroupDetails: { path: "/groups/:id" },
    GroupCreate: { path: "/groups/create" },
    GroupEdit: { path: "/groups/:id/edit" },

    // MyProfile
    MyProfileEdit: { path: "/myprofile/:id/edit" },

    // Subscription Management
    SubscriptionList: { path: "/subscription-management" },


    // Error pages
    /* NotFound: { path: "/examples/404" },
    ServerError: { path: "/examples/500" }, */

    // Documentation
    /* DocsOverview: { path: "/documentation/overview" },
    DocsDownload: { path: "/documentation/download" },
    DocsQuickStart: { path: "/documentation/quick-start" },
    DocsLicense: { path: "/documentation/license" },
    DocsFolderStructure: { path: "/documentation/folder-structure" },
    DocsBuild: { path: "/documentation/build-tools" },
    DocsChangelog: { path: "/documentation/changelog" }, */

    // Components
    /* Accordions: { path: "/components/accordions" },
    Alerts: { path: "/components/alerts" },
    Badges: { path: "/components/badges" },
    Widgets: { path: "/widgets" },
    Breadcrumbs: { path: "/components/breadcrumbs" },
    Buttons: { path: "/components/buttons" },
    Forms: { path: "/components/forms" },
    Modals: { path: "/components/modals" },
    Navs: { path: "/components/navs" },
    Navbars: { path: "/components/navbars" },
    Pagination: { path: "/components/pagination" },
    Popovers: { path: "/components/popovers" },
    Progress: { path: "/components/progress" },
    Tables: { path: "/components/tables" },
    Tabs: { path: "/components/tabs" },
    Tooltips: { path: "/components/tooltips" },
    Toasts: { path: "/components/toasts" },
    WidgetsComponent: { path: "/components/widgets" } */
};